<template>
    <div class='tw-w-full tw-bg-white tw-rounded-md tw-shadow-sm tw-p-4 tw-flex tw-flex-col tw-gap-3' style="min-width:min(40rem, calc(100vw - 4rem));">
        <div class="tw-flex tw-flex-col">
            <p class='tw-font-bold tw-text-lg tw-capitalize'>{{ nombre }}</p>
            <p class='tw-text-sm tw-text-gray-500'>
                {{ new Date(datos?.datos?.fecha).toLocaleDateString() }}
            </p>
        </div>
        
        <hr class='tw-w-full' />
        
        <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
            <div class="tw-flex-1">
                <p class='tw-text-xs tw-uppercase tw-text-gray-500'>Profesional</p>
                <p class='tw-font-medium'>{{ medico?.nombre || 'No especificado' }}</p>
            </div>
            <div class="tw-flex-1">
                <p class='tw-text-xs tw-uppercase tw-text-gray-500'>Especialidad</p>
                <p class='tw-font-medium'>{{ especialidad?.nombre || 'No especificado' }}</p>
            </div>
        </div>
        
        <div v-if="practicas && practicas.length > 0">
            <p class='tw-text-xs tw-uppercase tw-text-gray-500'>Prácticas realizadas</p>
            <ul class="tw-pl-0 tw-mt-2">
                <li v-for="(practica, index) in practicas" :key="index" 
                    class="tw-flex tw-items-center tw-mb-1">
                    <span class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-green-500 tw-mr-2"></span>
                    <span>{{ practica.descripcion || practica.nombre || practica }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>
<script lang='ts'>
    import {computed, defineComponent, onMounted, ref } from 'vue'
    import axios from '@/plugins/axios';

    export default defineComponent({
        name:'ResultadoInfo',
        props:{
            id:{
                type:String,
                required:true
            },
        },
        setup(props,{emit}){
            const datos = ref<any>(null)

            const obtenerDatos = async () => {
                try {
                    const { data } = await axios.get(`/historia-clinica-get-registros/${props.id}`)

                    if(data.tipo === 'PAC') {
                        const { data: estudio} = await axios.post('/turnos/get-estudio', { id: data.datos.idturno})
                        data.datos.prestaciones = estudio.prestaciones
                    }


                    datos.value = data
                } catch (error) {
                    console.log(error);
                }
            }


            const medico = computed(() => {
                return datos.value?.medico
            })

            const especialidad = computed(() => {
                return datos.value?.especialidad
            })

            const practicas = computed(() => {
                return datos.value?.datos?.prestaciones
            })

            const nombre = computed(() => {
                if(datos.value?.tipo === 'PAC') {
                    return 'diagnostico por imagen'
                }
                return 'Resultado De Laboratorio'
            })


            onMounted(() => {
                obtenerDatos()
            })
            return{
                datos,
                medico,
                especialidad,
                practicas,
                nombre,
            }
        }
    })
</script>
<style lang='scss'></style>